import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["disabled"];
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
import { SpriteIcons } from '@/user/components/common';
import { defaultButtonStyle, getIconSize } from './buttonStyle';
export default /*@__PURE__*/ _defineComponent({
    __name: 'OutlinedButton',
    props: {
        className: {},
        color: {},
        mobileSize: {},
        desktopSize: {},
        disabled: { type: Boolean, default: false },
        iconName: {},
        iconPosition: { default: 'left' },
        iconClassName: { default: '' }
    },
    setup(__props) {
        const props = __props;
        const button = tv({
            extend: defaultButtonStyle,
            variants: {
                color: {
                    blue: 'text-blue-700 hover:text-blue-900 disabled:text-blue-200',
                    gray: 'text-gray-900 hover:text-gray-800 disabled:text-gray-300',
                    white: 'text-white hover:text-gray-400 disabled:text-gray-800',
                },
                mobileSize: {
                    large: 'text-body-3 gap-8 border-2 px-28 py-11',
                    medium: 'text-body-5 border-1 gap-4 px-20 py-8',
                    small: 'text-body-6 border-1 px-18 gap-4 py-8',
                },
                desktopSize: {
                    large: 'desktop:text-body-3 desktop:gap-8 desktop:px-28 desktop:py-11',
                    medium: 'desktop:text-body-5 desktop:gap-4 desktop:px-20 desktop:py-9',
                    small: 'desktop:text-body-6 desktop:gap-4 desktop:px-18 desktop:py-8',
                },
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(_unref(button)({
                    color: props.color,
                    mobileSize: props.mobileSize,
                    desktopSize: props.desktopSize,
                    class: props.className,
                })),
                disabled: props.disabled,
                type: "button"
            }, [
                (props.iconName && props.iconPosition === 'left')
                    ? (_openBlock(), _createBlock(_unref(SpriteIcons), {
                        key: 0,
                        class: _normalizeClass(_unref(clsx)(_unref(getIconSize)(props.desktopSize, props.mobileSize), 'shrink-0', props.iconClassName)),
                        name: props.iconName
                    }, null, 8, ["class", "name"]))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default"),
                (props.iconName && props.iconPosition === 'right')
                    ? (_openBlock(), _createBlock(_unref(SpriteIcons), {
                        key: 1,
                        class: _normalizeClass(_unref(clsx)(_unref(getIconSize)(props.desktopSize, props.mobileSize), 'shrink-0', props.iconClassName)),
                        name: props.iconName
                    }, null, 8, ["class", "name"]))
                    : _createCommentVNode("", true)
            ], 10, _hoisted_1));
        };
    }
});
